import App from './containers/App';
import TextPage from './containers/pages/TextPage';
import ProductPage from './containers/pages/Product';
import CartPage from './containers/pages/CartPage';

const routes = [
	{ component: App,
		routes: [
			{
				path: '/shop/:productUri',
				component: ProductPage,
			},
			{
				path: '/shop',
				component: TextPage,
			},
			{
				path: '/bag',
				exact: true,
				component: CartPage,
			},
			{
				path: '/:page',
				component: TextPage,
			},
			{
				path: '*',
				component: TextPage,
			},
		],
	},
];

export default routes;



// WEBPACK FOOTER //
// ./routes.js